"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the percentage difference between two numbers, and the scale multiplier
 * that would be applied to change A to B
 *
 * @param A
 * @param B
 */
exports.default = (A, B) => {
    const scale = Math.abs((B - A) / A);
    const percentage = 100 * scale;
    const scaleMultiplier = A > B ? 1 - scale : 1 + scale;
    return {
        percentage,
        scaleMultiplier,
    };
};
